import React from 'react';
import { FlexRow, formatNumber } from '@make-software/tg-mini-app-ui';

import { StyledEarnIcon } from '@/shared';
import EarnIcon from '@/shared/assets/icons/ic-earn.svg';

import { ActivityContainer, ActivityPoints, ActivityText } from './styled';

export interface IRoundStat {
  label: string;
  value: number;
  total?: number;
  iconFill?: string;
}

export const OnchainActivityRow: React.FC<IRoundStat> = ({ label, value, total, iconFill }) => (
  <ActivityContainer justify="space-between">
    <ActivityText weight={3}>{label}</ActivityText>

    <FlexRow align="center" gap={5}>
      <StyledEarnIcon src={EarnIcon} size={14} fillColor={iconFill} />
      {total == null ? (
        <ActivityPoints weight={3} color="#FFFFFF" aria-label={`${label} ${value}`}>
          {formatNumber(value)}
        </ActivityPoints>
      ) : (
        <ActivityPoints weight={3} color="#FFFFFF" aria-label={`${label} ${value} of ${total}`}>
          {formatNumber(value)}/
          <ActivityPoints weight={3} color="#A9AAAD">
            {formatNumber(total)}
          </ActivityPoints>
        </ActivityPoints>
      )}
    </FlexRow>
  </ActivityContainer>
);
